import { render, staticRenderFns } from "./UnTabsUiHorizontal.vue?vue&type=template&id=f922f948&lang=pug&"
import script from "./UnTabsUiHorizontal.vue?vue&type=script&lang=js&"
export * from "./UnTabsUiHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports